import React from 'react';
import { CTAButton } from './Shared';
export const Hero = () => {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-40 pb-20 md:pt-48 md:pb-32 px-4 overflow-hidden" data-id="element-57">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-prime-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-58" />

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-59">
        <div className="inline-block mb-6 px-4 py-1 border border-prime-gold/30 rounded-full bg-prime-gold/5 text-prime-gold text-sm font-semibold tracking-widest uppercase" data-id="element-60">
          The Prime Architect
        </div>

        <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-8 text-white" data-id="element-61">
          Cómo Reclamar el Vigor y el Cuerpo de tus 20s en solo{' '}
          <span className="text-prime-gold italic" data-id="element-62">90 Días</span>
        </h1>

        <p className="text-xl md:text-2xl text-prime-textMuted mb-8 max-w-4xl mx-auto leading-relaxed" data-id="element-63">
          Sin Terapias Médicas Innecesarias, Sin 'Dietas de Hambre' y Entrenando
          solo 35 Minutos... <br className="hidden md:block" data-id="element-64" />
          <span className="text-white font-medium" data-id="element-65">
            — Incluso Si Sientes Que Tu Metabolismo Se Ha Detenido Por Completo.
          </span>
        </p>

        <div className="w-24 h-1 bg-prime-gold mx-auto mb-8 rounded-full opacity-50" data-id="element-66" />

        <p className="text-lg md:text-xl text-prime-text mb-12 max-w-3xl mx-auto font-light border-l-4 border-prime-gold pl-6 text-left italic" data-id="element-67">
          "El Protocolo de Arquitectura Hormonal diseñado específicamente para
          hombres de 40+ que están cansados de sentirse fatigados, con sobrepeso
          y 'fuera de juego' en su propia vida."
        </p>

        <CTAButton onClick={scrollToPricing} data-id="element-68">
          SÍ, QUIERO RECLAMAR MI VIGOR AHORA
        </CTAButton>

        <p className="mt-4 text-sm text-prime-textMuted flex items-center justify-center gap-2" data-id="element-69">
          <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-70" />
          Acceso Inmediato • Garantía de 60 Días
        </p>
      </div>
    </section>;
};